import React, {useEffect} from "react";

import styles from "./LocationsTab.module.css"
import {Button, ButtonState} from "../../../../elements/button/Button";
import {LocationTable} from "../LocationTable";
import {useAppDispatch} from "../../../../../app/hooks";
import {FormName, openForm} from "../../../../elements/formProvider/formSlice";
import {MenuItem, updateSelectedMenuItem} from "../../../platform/platformSlice";

export const LocationsTab: React.FC = () => {

    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(updateSelectedMenuItem(MenuItem.LOCATIONS))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = () => {
        dispatch(openForm({name: FormName.CREATE_LOCATION}))
    }

    return <div className={styles.wrapper}>
        <div className={styles.headerSectionWrapper}>
            <span className={styles.title}>Locations</span>
            <Button
                title={"Create location"}
                iconSrc={"/plusIcon.svg"}
                state={ButtonState.PRIMARY}
                handleClick={handleClick}
            />
        </div>
        <LocationTable/>
    </div>
}
